let config = {};

config.baseURL = 'https://api.app.invitee.com.br/api/v1/';
config.normalURL = 'https://api.app.invitee.com.br/';

export default config
